import { DayOfWeek, MealOfDay, MealPlanWithMeals } from './mealplan';
export class ShoppingListExclusion {
    public static ExtractShoppingListExclusionsFromMealPlan(mealPlan: MealPlanWithMeals): ShoppingListExclusion[] {
        if (mealPlan == null) {
            throw Error('Expected mealPlan to exists in order to extract exclusions ');
        }
        if (mealPlan.mealSchedule == null) {
            throw Error('Expected mealPlan to exists in order to extract exclusions ');
        }
        const exclusions: ShoppingListExclusion[] = [];
        mealPlan.mealSchedule.forEach((mealOfDay, dayOfWeekKey) => {
            mealOfDay.forEach((meal, mealOfDayKey) => {
                if (meal.isInShoppingList === false) {
                    const exclusion = new ShoppingListExclusion();
                    exclusion.dayOfWeek = dayOfWeekKey;
                    exclusion.timeOfDay = mealOfDayKey;
                    exclusions.push(exclusion);
                }
            });
        });

        return exclusions;
    }

    public dayOfWeek: DayOfWeek;
    public timeOfDay: MealOfDay;
}
